import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const STATUS_CLASS = {
    pending:     'bg-secondary',
    queued:      'bg-secondary',
    sent:        'bg-primary',
    delivered:   'bg-success',
    bounced:     'bg-warning text-dark',
    complained:  'bg-danger',
    failed:      'bg-danger',
    skipped:     'bg-light text-dark',
    unsubscribed:'bg-light text-dark',
    suppressed:  'bg-light text-dark',
};

export default function RecipientTable({ campaignId, recipients, total, page, pageSize, onPageChange, onFilter }) {
    const navigate = useNavigate();
    const [search, setSearch] = useState('');
    const [statusFilter, setStatusFilter] = useState('');

    const applyFilter = () => {
        onFilter({ search, status: statusFilter });
    };

    const handleKeyDown = (e) => {
        if (e.key === 'Enter') applyFilter();
    };

    const totalPages = Math.ceil(total / pageSize);

    return (
        <div>
            <div className="row g-2 mb-3">
                <div className="col-md-5">
                    <input
                        className="form-control form-control-sm"
                        placeholder="Search email or name…"
                        value={search}
                        onChange={(e) => setSearch(e.target.value)}
                        onKeyDown={handleKeyDown}
                    />
                </div>
                <div className="col-md-4">
                    <select
                        className="form-select form-select-sm"
                        value={statusFilter}
                        onChange={(e) => setStatusFilter(e.target.value)}
                    >
                        <option value="">All statuses</option>
                        <option value="pending">Pending</option>
                        <option value="sent">Sent</option>
                        <option value="delivered">Delivered</option>
                        <option value="bounced">Bounced</option>
                        <option value="complained">Complained</option>
                        <option value="failed">Failed</option>
                        <option value="unsubscribed">Unsubscribed</option>
                        <option value="skipped">Skipped</option>
                        <option value="suppressed">Suppressed</option>
                    </select>
                </div>
                <div className="col-md-3">
                    <button className="btn btn-sm btn-outline-secondary" onClick={applyFilter}>
                        Filter
                    </button>
                </div>
            </div>

            {recipients.length === 0 ? (
                <p className="text-muted small">No recipients match the current filter.</p>
            ) : (
                <div className="table-responsive">
                    <table className="table table-sm table-hover">
                        <thead>
                            <tr>
                                <th>Email</th>
                                <th>Name</th>
                                <th>Source</th>
                                <th>Status</th>
                                <th>Sent at</th>
                            </tr>
                        </thead>
                        <tbody>
                            {recipients.map((r) => (
                                <tr
                                    key={r.id}
                                    style={{ cursor: 'pointer' }}
                                    onClick={() =>
                                        navigate(`/league-manager/campaigns/${campaignId}/recipients/${r.id}/`)
                                    }
                                >
                                    <td className="small">{r.email}</td>
                                    <td className="small">{r.first_name} {r.last_name}</td>
                                    <td className="small">{r.source_display}</td>
                                    <td>
                                        <span className={`badge ${STATUS_CLASS[r.status] || 'bg-secondary'}`}>
                                            {r.status_display}
                                        </span>
                                    </td>
                                    <td className="small">
                                        {r.sent_at ? new Date(r.sent_at).toLocaleString() : '—'}
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            )}

            {totalPages > 1 && (
                <nav>
                    <ul className="pagination pagination-sm justify-content-end">
                        <li className={`page-item ${page <= 1 ? 'disabled' : ''}`}>
                            <button className="page-link" onClick={() => onPageChange(page - 1)}>
                                Previous
                            </button>
                        </li>
                        <li className="page-item disabled">
                            <span className="page-link">
                                {page} / {totalPages} ({total} total)
                            </span>
                        </li>
                        <li className={`page-item ${page >= totalPages ? 'disabled' : ''}`}>
                            <button className="page-link" onClick={() => onPageChange(page + 1)}>
                                Next
                            </button>
                        </li>
                    </ul>
                </nav>
            )}
        </div>
    );
}
